<template>
  <div class="model-card-wrapper">
    <div class="model-card">
      <div class="image" :style="[model.image !== null ? {'background-image': 'url(' + model.image + ')'} : '']" @click="goto(model.url)"></div>
      <div class="content">
        <h2><a :href="model.url">{{ model.name }}</a></h2>
        <p v-html="model.blurb"></p>
        <p><a :href="model.url">Learn More <i class="fas fa-angle-right"></i></a></p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ModelCard',
  props: {
    model: Object
  },
  methods: {
    goto: function (url) {
      window.location = url
    }
  }
}
</script>
